export default {
      id: "ic_help-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic_help-usage",
      toString: function () {
        return this.url;
      }
    }